<template>
  <v-card elevation="0">
    <v-toolbar class="red pb-4" color="white" elevation="4" flat height="150px">
      <div class="container mb-1">
        <div class="row justify-content-start">
          <div class="col-8">
            <v-text-field
              class="mx-4"
              flat
              hide-details
              label="Search"
              solo-inverted
            ></v-text-field>
          </div>
          <div class="col-4">
            <v-btn style="width: 75%" large outlined @click="this.openCentersDialog">
              <v-icon class="mr-2"> mdi-note-plus-outline</v-icon>
              Add Donation Center</v-btn
            >
          </div>
          <div class="col-12"><h2>Donation Centers</h2></div>
        </div>
      </div>
      <div>
        <dialog-container>
          <div v-if="centersDialog" slot="content">
            <add-donation-center-form />
          </div>
        </dialog-container>
      </div>
    </v-toolbar>
    <v-divider class="mb-12"> </v-divider>

    <v-row>
      <v-col
        cols="6"
        sm="6"
        md="6"
        v-for="(item, index) in centers"
        :key="index"
      >
        <donation-centers-list
          :id="item.id"
          :name="item.name"
          :address="item.address"
          :city="item.city"
          :country="item.country"
          :location="item.location"
          :phoneNumber="item.phoneNumber"
        />
      </v-col>
    </v-row>
  </v-card>
</template> 

<script>
import { mapFields } from "vuex-map-fields";
import { mapActions } from "vuex";
import { eventBus } from "@/main.js";

import DonationCentersList from "../components/DonationCentersList";
import DialogContainer from "../shared/components/dialogContainer";
import AddDonationCenterForm from "../forms/AddDonationCenterForm";

export default {
  name: "Donations",
  async created() {
    await this.fetchAllDonationCenters();
  },
  components: {
    Map,
    DonationCentersList,
    AddDonationCenterForm,
    DialogContainer,
  },
  computed: {
    ...mapFields("donation", ["donationCenters"]),
  },
  data() {
    return {
      tab: null,
      tabs: null,
      map: require("../assets/map1.jpg"),
      centersDialog: false,
      text:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      centers: [],
      inventory: [],
    };
  },
  methods: {
    ...mapActions("donation", ["fetchAllDonationCenters"]),
    openCentersDialog() {
      this.centersDialog = true;
      eventBus.$emit("dialogToggle", true);
  
    },
  },
  watch: {
    donationCenters: {
      immidate: true,
      handler(value) {
        if (value.length != 0) {
          value.map((center, index) => {
            this.centers.push({
              id: center.id,
              name: center.content.name,
              address: center.content.address,
              city: center.content.city,
              country: center.content.country,
              location: center.content.location,
              phoneNumber: center.content.phoneNumber,
            });
          });
        }
      },
    },
  },
};
</script>



